import templateUrl from './service-info.html';
import findIndex from 'lodash/findIndex';
import clone from 'lodash/clone';
import size from 'lodash/size';
import filter from 'lodash/filter';
import head from 'lodash/head';

export const serviceInfoComponent = {
	bindings: {
		details: '<',
		serviceAreas: '<',
		serviceTypeList: '<',
		onSubmit: '&',
		onCancel: '&',
		onPrevious: '&',
		showNextButton: '@',
		showPreviousButton: '@',
		prevDetails: '<',
		newDetails: '<',
		parentSlug: '@'
	},

	templateUrl,

	controller: class ServiceInfoComponent {
		constructor($state, $parse, Constants, CompareObjectService, ModalService) {
			'ngInject';

			this.$state = $state;
			this.$parse = $parse;
			this.constants = Constants;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
		}

		$onInit() {
			this.defaultServiceTypes = clone(this.details.serviceInfo.serviceType);
			this.defaultServiceAreas = clone(this.details.serviceInfo.serviceArea);
			this._showNextButton = this.$parse(this.showNextButton || 'true')(true);
			this._showPreviousButton = this.$parse(this.showPreviousButton || 'true')(true);
			this.details = this.details || {};

			this.options = [{
				id: 1,
				title: 'Yes'
			}, {
				id: 2,
				title: 'No'
			}];

			if (!this.details.serviceInfo.costing) {
				this.defaultSelectedCostingOptionId = 1;
				this.details.serviceInfo.costing = 1;
			} else {
				this.defaultSelectedCostingOptionId = this.details.serviceInfo.costing;
			}

			this.costingOptions = [{
				id: 1,
				title: '$'
			}, {
				id: 2,
				title: '$$'
			}, {
				id: 3,
				title: '$$$'
			}];
			
			this.details.serviceInfo.specialRequirements = size(this.details.serviceInfo.specialRequirements) > 0 ? this.details.serviceInfo.specialRequirements : [{
				id: 'wheelchair_access',
				title: 'wheelchair access',
				isSelected: false
			}, {
				id: 'door_to_door',
				title: 'door to door',
				isSelected: false
			}, {
				id: 'door_through_door',
				title: 'door through door',
				isSelected: false
			}, {
				id: 'curb_to_curb',
				title: 'curb to curb',
				isSelected: false
			}];

			this.isCheckedDestinationForServiceAreaOption = [{
				id: 1,
				title: 'Search destination in service area',
				isSelected: this.details.serviceInfo.isCheckedDestinationForServiceArea,
				isDisabled: false
			}];
			this._enableDisabledDestinationCheckOption();

			this.defaultSelectedMedicaidOptionId = this.details.serviceInfo.medicaidSupport ? 1 : 2;
			this.defaultSelectedVeteranOptionId = this.details.serviceInfo.veteranSupport ? 1 : 2;

			this.details.serviceInfo.medicaidSupport = this.defaultSelectedMedicaidOptionId === 1 ? true : false;
			this.details.serviceInfo.veteranSupport = this.defaultSelectedVeteranOptionId === 1 ? true : false;
		}

		onChangeCosting({ id }) {
			this.details.serviceInfo.costing = parseInt(id);
		}

		//category select function for autocomplete
		onSelectItem(value) {
			const index = findIndex(this.details.serviceInfo.serviceType, ({ id }) => id === value.id);
			const deletedServiceTypes = filter(this.details.serviceInfo.serviceType, ['status', 2]);
			if (size(this.details.serviceInfo.serviceType) === 0 || size(deletedServiceTypes) === size(this.details.serviceInfo.serviceType)) {
				if (value.name === "Private Transportation") {
					this.defaultSelectedCostingOptionId = 2;
					this.details.serviceInfo.costing = 2;
				} else if (value.name === "Paratransit") {
					this.defaultSelectedCostingOptionId = 3;
					this.details.serviceInfo.costing = 3;
				} else {
					this.defaultSelectedCostingOptionId = 1;
					this.details.serviceInfo.costing = 1;
				}
			}
			if (index === -1) {
				value.status = this.constants.STATUS.ADD;
				this.details.serviceInfo.serviceType.push(value);
			} else {
				this.details.serviceInfo.serviceType[index].status = -1;
			}

			this._enableDisabledDestinationCheckOption();
		}

		//category remove function for autocomplete
		onRemoveTag(value) {
			const index = findIndex(this.details.serviceInfo.serviceType, ({ name }) => name === value);
			if (this.details.serviceInfo.serviceType[index].status !== 0) {
				this.details.serviceInfo.serviceType[index].status = this.constants.STATUS.DELETE;
			}
			const serviceTypeIndex = findIndex(this.details.serviceInfo.serviceType, ({ name }) => name === value);
			this.details.serviceInfo.serviceType = this.details.serviceInfo.serviceType.reduce((serviceType, value, index) => {
				if (serviceTypeIndex === index) {
					if (this.details.serviceInfo.serviceType[index].status !== this.constants.STATUS.ADD) {
						value.status = this.constants.STATUS.DELETE;
						serviceType.push(value);
					}
				} else {
					serviceType.push(value);
				}
				return serviceType;
			}, []);

			this._enableDisabledDestinationCheckOption();
		}


		//category select function for autocomplete
		onSelectServiceArea(value) {
			const index = findIndex(this.details.serviceInfo.serviceArea, ({ id }) => id === value.id);
			if (index === -1) {
				value.status = this.constants.STATUS.ADD;
				this.details.serviceInfo.serviceArea.push(value);
			} else {
				this.details.serviceInfo.serviceArea[index].status = -1;
			}
		}

		//category remove function for autocomplete
		onRemoveServiceAreaTag(value) {
			const serviceAreaIndex = findIndex(this.details.serviceInfo.serviceArea, ({ name }) => name === value);
			this.details.serviceInfo.serviceArea = this.details.serviceInfo.serviceArea.reduce((serviceArea, value, index) => {
				if (serviceAreaIndex === index) {
					if (this.details.serviceInfo.serviceArea[index].status !== this.constants.STATUS.ADD) {
						value.status = this.constants.STATUS.DELETE;
						serviceArea.push(value);
					}
				} else {
					serviceArea.push(value);
				}
				return serviceArea;
			}, []);
		}

		onChangeMedicaid({ id }) {
			this.details.serviceInfo.medicaidSupport = id === '1' ? true : false;
		}

		onChangeVeteran({ id }) {
			this.details.serviceInfo.veteranSupport = id === '1' ? true : false;
		}

		_enableDisabledDestinationCheckOption() {
			const selectedServiceTypes = this.details.serviceInfo.serviceType.filter(serviceType => serviceType.status !== this.constants.STATUS.DELETE);
			if(size(selectedServiceTypes) === 1 && head(selectedServiceTypes).name === "Public Transit") {
				head(this.isCheckedDestinationForServiceAreaOption).isSelected = false;
				head(this.isCheckedDestinationForServiceAreaOption).isDisabled = true;	
			} else {
				head(this.isCheckedDestinationForServiceAreaOption).isDisabled = false;	
			}
		}

		_onCancel() {
			this.saveData = angular.copy(this.prevDetails);
			const _details = angular.copy(this.newDetails);
			const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);

			if (isUpdated) {
				this.modalService.open({
					details: {
						bodyMessage: 'Changes done will be reverted. Continue?'
					},

					buttons: [
						{
							name: 'No'
						},
						{
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}
					]
				});
			} else {
				this._redirectToParentState(this.parentSlug);
			}

			function onSubmit() {
				this._redirectToParentState(this.parentSlug);
			}
		}

		_redirectToParentState(slug) {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: slug
			});
		}

		_onSubmit() {
			this.details.serviceInfo.isCheckedDestinationForServiceArea = head(this.isCheckedDestinationForServiceAreaOption).isSelected;
			this.onSubmit({
				$event: {
					serviceInfo: this.details.serviceInfo
				}
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/service-info/service-info.component.js